import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import "bootstrap-icons/font/bootstrap-icons.css";
import RCB1 from '../Images/RCB1.jpg';
import NIB from '../Images/NIB.jpg';

function Branch() {
    return (
        <>
            <div className="py-5 a11" id="contact">
                <Container>
                    <h3 className="text-center mb-5">Our Branches</h3>
                    <Row className="align-items-center">
                        {/* Left Side - Branch 1 Details */}
                        <Col md={4} className="flex-grow-1">
                            <h5 className="my-4">Nava India Branch 1</h5>
                            <div className="cen">
                                <p>
                                    <b>Address:-</b> No.336/2, Ground Floor, <br />
                                    Mayflower Valencia, Nava India, Peelamedu, Coimbatore, Tamil Nadu - 641004
                                </p>
                                <p>
                                    <b>Phone:-</b> 8667390454
                                </p>
                            </div>
                        </Col>

                        {/* Center - Image */}
                        <Col md={3} className="d-flex justify-content-center">
                            <img src={NIB} className="a12" />
                        </Col>

                        {/* Right Side - Branch 2 Details */}
                        <Col md={4} className="flex-grow-1">
                            <h5 className="my-4">Nava India Branch 2</h5>
                            <div className="cen">
                                <p>
                                    <b>Address:-</b> No.336/2, 6th Floor, <br />
                                    Mayflower Valencia, Nava India, Peelamedu, Coimbatore, Tamil Nadu - 641004
                                </p>
                                <p>
                                    <b>Phone:-</b> 8667390454
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


        </>
    );
}

export default Branch;